import { combineReducers } from 'redux'

import { user } from './auth_reducer'
import {
  topics,
  searchByKeword,
  libraryFilter
} from './topics_reducer'
import {
  compare
} from './compare_reducer'
import {
  homepage
} from './homepage_reducer'
import {
  tracker
} from './tracker_reducer'
import {
  uMap
} from './umap_reducer'
import {
  rediscover
} from './rediscover_reducer'
import {
  calendar
} from './calendar_reducer'
import {
  audienceAcquisition
} from './audienceAcquisition_reducer'
import {
  subscriber
} from './subscriber_reducer'
import {
  attentionIndex
} from './attention_reducer'
import { shortcuts } from './shortcuts_reducer'
import { sidebar } from './sidebar_reducer'
import { budgetSubscribers } from './budget_subscribers_reducer'
import { sov } from './sov_reducer'
import { globalAttentionIndex } from './globalAttentionIndex_reducer'
import { chat } from './chat_reducer'
// import {
//   channelDetailsById
// } from './channel_reducer'
// import { config } from './config_reducer'

// Outline of store. This is here only for documentation
/*
const StoreDocs = {
  topics: {
    // DefaultTopicsState
    list: {
      // DefaultTopicsListState
      // topicsList
    },
    byId: {
      // Default is {}
      // topicsById
      ['TOPIC-ID']: {
        details: {
          // DefaultTopicDetailsState
          // entityDetails
          // videoChannelDetails
        },
        metrics: {
          // DefaultTopicMetricsState
          // topicMetrics
        }
        plan: {
          // DefaultTopicPlanTopLevelState
          // topicsByIdPlan
          currentFilters: 'Filters',
          ['FILTERS']: {
            // DefaultTopicPlanFilteredState
            // topicByIdPlanFilter
            currentPage: 1,
            endOfResult: false,
            ['PAGE']: {
              // DefaultTopicPlanState
              // topicByIdPlanFilterPage
              // Delegates to entityPlan and videoChannelPlan
            }
          }
        }
      }
    }
  }
}
*/

const rootReducer = combineReducers({
  user,
  topics,
   shortcuts,
  compare,
  homepage,
  tracker,
  uMap,
  searchByKeword,
  libraryFilter,
  rediscover,
  calendar,
  audienceAcquisition,
  subscriber,
  attentionIndex,
  sidebar,
  budgetSubscribers,
  sov,
  globalAttentionIndex,
  chat
})

export default rootReducer
